import { AppComponent } from './app/app.component'
import { createApplication } from '@angular/platform-browser'
import { createCustomElement } from '@angular/elements'
import { appConfig } from './app/app.config'

(async () => {
   const app = await createApplication(appConfig)

   const inputElement = createCustomElement(AppComponent, {
      injector: app.injector,
   })
   customElements.define('cdi-research-assistant', inputElement)
})()